<script setup lang="ts">
const { locale } = useI18n()
const localePath = useLocalePath()
const switchLocalePath = useSwitchLocalePath()
const getRouteBaseName = useRouteBaseName()
const route = useRoute()
const isEvidencePage = computed(() => getRouteBaseName(route) === 'evidence-epoukazu')

const props = defineProps<{
  phone?: boolean
}>()

const languageDefinitions = ['cs', 'sk', 'en']

const open = ref(false)
const root = ref<HTMLElement | null>(null)

function close() {
  open.value = false
}

function onPointerDown(event: PointerEvent) {
  if (!root.value?.contains(event.target as Node)) close()
}

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape') close()
}

// The menu used to open on :hover alone, which meant it could never be opened
// on a touch device -- Tailwind emits group-hover inside @media (hover: hover).
watch(open, (isOpen) => {
  if (isOpen) {
    document.addEventListener('pointerdown', onPointerDown)
    document.addEventListener('keydown', onKeydown)
  } else {
    document.removeEventListener('pointerdown', onPointerDown)
    document.removeEventListener('keydown', onKeydown)
  }
})

onUnmounted(() => {
  document.removeEventListener('pointerdown', onPointerDown)
  document.removeEventListener('keydown', onKeydown)
})
</script>

<template>
  <div ref="root" class="relative flex flex-row justify-center" :class="{ 'text-3xl!': props.phone }">
    <button
      type="button"
      class="flex cursor-pointer flex-row items-center gap-1"
      :aria-label="$t('header.languageAriaLabel')"
      aria-haspopup="true"
      :aria-expanded="open"
      @click="open = !open"
    >
      {{ locale }}
      <Icon
        name="fa6-solid:chevron-down"
        class="h-3 w-3 transition-transform duration-200"
        :class="{ 'rotate-180': open }"
      />
    </button>
    <div v-if="open" class="absolute left-0 top-6 z-50 w-full" :class="{ 'top-9': props.phone }">
      <div
        class="mx-auto flex w-max flex-col gap-1 rounded-md bg-white px-4 py-2"
        :class="{ 'bg-gray-100': props.phone }"
      >
        <NuxtLink
          v-for="lang in languageDefinitions.filter((lang) => lang !== locale)"
          :key="lang"
          :to="isEvidencePage ? switchLocalePath(lang) : localePath('/', lang)"
          class="link font-bold hover:text-optilynx-pink"
          @click="close"
        >
          {{ lang }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>
